module.exports = __webpack_public_path__ + "media/חם.b56fcfc0.mp3";